import AdReportApi from '@/api/AdReport'

/**
 * キャンペーンレポートを取得して返す。
 */
const fetchCampaignReport = async ({
  advertiserId,
  insertionOrderId,
  insertionOrderBudgetIds,
  campaignBudgetIds,
  period,
}) => {
  const params = {
    query: {
      insertionOrder: {
        ids: [insertionOrderId],
      },
      ioBudget: {
        ids: insertionOrderBudgetIds,
      },
      cpBudget: {
        ids: campaignBudgetIds,
      },
      dimensionType: 'total',
      groupBy: 'campaign',
      period: period,
    },
  }
  const result = await AdReportApi.getCampaignReport(advertiserId, params)

  return result
}

export default fetchCampaignReport
